import React, { useEffect, useState, useRef } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import initPage from '../js/ui';
import URL from '../constants/url'
import Header from '../components/Header';
import Footer from '../components/Footer';
import Main from '../pages/Main/Main';
import About from '../pages/About/About';
import Contact from '../pages/Contact/Contact';
import Error from '../components/Error';

import Products from '../pages/Products/Products';
import Private from 'components/Private';
import Main2 from 'pages/Main/Main2';
import ScrollButton from 'components/ScrollButton';
import Products_old from 'pages/Products/Products_old';
import ScrollToTop from 'components/ScrollToTop';

const RootRoutes = () => {
    const [mounted, setMounted] = useState(false);
    const location = useLocation();
    const isMounted = useRef(false);
    useEffect(() => {
        if (!isMounted.current) {
            isMounted.current = true;
            setMounted(true);
            // initPage();
        }

    }, [location, mounted]);
    if (mounted) {
        return (
            <>
            <ScrollToTop />
            {/* <Header /> */}
            <Routes>
                
                {/* <Route path={URL.ERROR} element={<Error />} /> */}
                <Route path={URL.ERROR} element={<Error />} />
                <Route path={URL.MAIN} element={<Main2 />} />
                {/* <Route path={URL.MAIN_NEW} element={<Main />} /> */}
                <Route path={URL.INDEX} element={<Main2 />} />
    
                <Route path={URL.ABOUT} element={<About/>} />
                <Route path={URL.PRODUCTS} element={<Products/>} />
                {/* <Route path={URL.PRODUCTS_OLD} element={<Products_old/>} /> */}
                
                <Route path={URL.CONTACT} element={<Contact/>} />

                <Route path={URL.PRIVATE} element={<Private/>}/>
               
                <Route path="*" element={<Main2 />} />
               
                <Route path= "/company.do" element={<About />} />
                <Route path= "/business.do" element={<Products />} />
                <Route path= "/history.do" element={<About />} />
                <Route path= "/support.do" element={<Contact />} />
               
            </Routes>
            <ScrollButton pathName={location.pathname} />
            {/* <Footer/> */}
            </>
        )
        // return (
        //     <Routes>
        //         <Route path={URL.ERROR} element={<Error />} />
        //         <Route path="*" element={<SecondRoutes/>} />
        //     </Routes>
        // )
    }
    // else {
    //     return (
    //         <>
    //         <Header />
    //         <Routes>
    //             <Route element={<Error />} />
    //         </Routes>
    //         </>
    //     )
    // }
   
}
const SecondRoutes = (props) => {
    const isMounted = useRef(false);
    useEffect(() => {
        if (!isMounted.current) {
            isMounted.current = true;
            console.log("제대로 나온거 맞음!!!")
            initPage();
        } else {
            console.log("제대로 나온거 맞음!!!2")
            // initPage();
        }
    }, []);
    return (
        <>
        <Header />
        <Routes>
            <Route path={URL.ERROR} element={<Error />} />
            {/* <Route path={URL.MAIN} element={<Main />} /> */}
            <Route path={URL.MAIN} element={<Main2 />} />

            <Route path={URL.ABOUT} element={<About/>} />
            <Route path={URL.PRODUCTS} element={<Products/>} />
            <Route path={URL.CONTACT} element={<Contact/>} />
           
            <Route path="*" element={<Error />} />
           
        </Routes>
        <Footer/>
        </>
    )
}
export default RootRoutes;